import React from 'react';

const NavigationDots = ({ active }) => (
  <div className="app_navigation">
    {['Home', 'About', 'Work', 'Skills', 'Contact'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="app_navigation-dot"
        style={active === item ? { backgroundColor: '#313BAC' } : {}}
        aria-label={`Navigate to ${item}`} // Keep accessibility label
      />
    ))}
  </div>
);

export default NavigationDots;